export const PULSARA_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'bmp']

export const convertImageSizeToKB = (size: number | null): string => {
  if (!size) return ''
  const sizeInKB = (size / 1024).toFixed(0)
  return `${sizeInKB} KB`
}
